import React from 'react';
import { CreditCard, Banknote, ArrowLeft, MapPin, Tag, X, Check, Gift, Store, Truck, Clock, Plus, ChevronRight, Trash2, Phone, CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { formatPrice } from '../../lib/utils';
import StampCard from '../StampCard';

const DeliveryTimeInfo = ({
  cart,
  orderType,
  t,
}) => (
  <>
              {orderType === 'delivery' && (
              <div className="flex items-start gap-3 p-4 rounded-lg bg-[#FFC107]/10 border border-[#FFC107]/30" data-testid="delivery-time-info">
                <Clock className="h-5 w-5 text-[#FFC107] mt-0.5 shrink-0" />
                <div>
                  <p className="font-medium text-[#FFC107]">
                    {t('checkout.fastDelivery')}*
                  </p>
                  {cart.items.some(item => item.category_id === 'cat-ethnic') && (
                    <p className="text-xs text-zinc-400 mt-1" data-testid="ethnic-disclaimer">
                      * {t('checkout.ethnicDisclaimer')}
                    </p>
                  )}
                </div>
              </div>
              )}
  </>
);

export default DeliveryTimeInfo;
